<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-speed-dial fixed
                v-model="detail"
                bottom
                right
                direction="top"
                :transition="transition">
    <template v-slot:activator>
      <v-card color="kbBlue" style="min-width: 250px; cursor: pointer">
        <v-card-actions v-if="importerProgress.finish" class="justify-center">
          <v-btn v-if="importerProgress.importType && importerProgress.importType === 'lists' && importerProgress.list"
                 text
                 outlined
                 block
                 @click.stop="createCampaign()">
            {{ $t('general.createCampaign') }}
          </v-btn>
          <div class="flex pl-2 white--text"
               v-if="!importerProgress.importType || importerProgress.importType === 'campaigns' || !importerProgress.list">
            {{ $t('general.importCompleted') }}
          </div>
          <v-btn icon color="white" text @click="clearCreatingList()">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-actions>

        <v-card-actions v-else class="justify-center">
          <span class="pl-2 white--text"
                v-if="importerProgress.importType === 'business'">
            {{ $t('general.importingBusinesses', { business: businessModule.p }) }}
          </span>

          <span class="pl-2 white--text"
                v-else>
            {{ $t('general.creatingList') }}
          </span>

          <v-spacer/>

          <v-btn icon dark text :class="{'rotate-icon': detail}">
            <v-icon>keyboard_arrow_up</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>

    <v-card class="px-2" text color="kbBlue">
      <v-card-text>
        <v-row class="white--text">
          <v-col class="text-center" cols="12" >
            <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="10"
              :value="progressAdded"
              color="kbWhite">
              {{ progressAdded }}%
            </v-progress-circular>
          </v-col>

          <v-col cols="12"
                 class="d-flex align-center justify-space-between pb-0"
                 v-for="(item, index) in importerProgressItems"
                 :key="index">
            <span class="text-capitalize">
              {{ item.text }}
            </span>
            <span>
              {{ item.value | formatNumber }}
            </span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-speed-dial>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      importerProgress: state => state.listsPersons.importerProgress
    }),
    importerProgressItems () {
      const {
        numberOfRows = 0,
        totalRecords = 0,
        uniqueRecords = 0,
        savedRecords = 0,
        updatedRecords = 0,
        insertedRecords = 0,
        duplicatedRecords = 0
      } = this.importerProgress
      return [
        { text: this.$t('general.numberOfRows'), value: numberOfRows },
        { text: this.$t('general.totalPeople'), value: totalRecords },
        { text: this.$t('general.uniquePeople'), value: uniqueRecords },
        { text: this.$t('general.savedPeople'), value: savedRecords },
        { text: this.$t('general.updatedPeople'), value: updatedRecords },
        { text: this.$t('general.insertedPeople'), value: insertedRecords },
        { text: this.$t('general.duplicatedPeople'), value: duplicatedRecords }
      ]
    },
    progressAdded () {
      if (this.importerProgress.index === 0) return 0
      return parseInt((this.importerProgress.index * 100) / this.importerProgress.totalUsers)
    }
  },
  data () {
    return {
      detail: true,
      transition: 'slide-y-reverse-transition'
    }
  },
  methods: {
    clearCreatingList () {
      this.$store.commit('CLEAR_IMPORTER_PROGRESS')
    },
    createCampaign () {
      this.$router.push({
        name: 'New Campaign',
        query: { list: this.importerProgress.list._id }
      })

      this.clearCreatingList()
    }
  }
}
</script>

<style>
.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
</style>
